import Internship1 from "assets/img/dialog civic/Internship1.jpg";
import Internship2 from "assets/img/dialog civic/Internship2.jpg";
import Internship3 from "assets/img/dialog civic/Internship3.jpg";
import Internship4 from "assets/img/dialog civic/Internship4.jpg";

export const videos = [
  {
    uri: "fiipregatitVideoBG.mp4",
    headerTitle: "CAMPANIE 1",
    date: "25.11.2023",
    title: "Împreună învățăm să fim #Imuni: Campanie națională de vaccinare 1",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 1",
    src: Internship1,
  },
  {
    uri: "test.mp4",
    headerTitle: "CAMPANIE 2",
    date: "26.11.2023",
    title: "Împreună învățăm să fim #Imuni: Campanie națională de vaccinare 2",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 2",
    src: Internship2,
  },
  {
    uri: "test2.mp4",
    headerTitle: "CAMPANIE 3",
    date: "27.11.2023",
    title: "Împreună învățăm să fim #Imuni: Campanie națională de vaccinare 3",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 3",
    src: Internship3,
  },
  {
    uri: "small.mp4",
    headerTitle: "CAMPANIE 4",
    date: "28.11.2023",
    title: "Împreună învățăm să fim #Imuni: Campanie națională de vaccinare 4",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 4",
    src: Internship4,
  },
];

export const cards = [
  {
    type: "content",
    content: {
      title: "Introducere",
      paragraph: "view.internship.paragraph1",
    },
    colSpan: 2,
    rowSpan: 2,
  },
  {
    type: "paragraph",
    content: {
      title: "Introducere",
      paragraph: "view.internship.paragraph2",
      paragraph2: "rezilienta.dgpc@mai.gov.ro",
      paragraph3: "view.internship.paragraph3",
    },
    colSpan: 2,
    rowSpan: 2,
  },

  { type: "image", content: Internship1, colSpan: 2, rowSpan: 1 },
  { type: "image", content: Internship2, colSpan: 1, rowSpan: 1 },
  { type: "image", content: Internship3, colSpan: 1, rowSpan: 1 },
];
